module.exports = __webpack_public_path__ + "6823eaaa063bc10d5d38a4ce7b26a8f8.png";